module.exports = __webpack_public_path__ + "img/icon_close_2.8888b505.svg";